import { useEffect, useRef, useState } from "react";
import { ResultType, useSpeechToText } from "../../utils/stt/useSpeechToText";
import { LMicrophone } from "./LMicrophone";

export const LWordMatch = ({ word, silentTime, onSilentTimeout, onMatch }: LWordMatchProps): JSX.Element => {
    const [isSpeaking, setIsSpeaking] = useState(false);
    const hasSpokenRef = useRef(false);

    const handlerOnStartSpeaking = (): void => {
        hasSpokenRef.current = true;

        console.log("sound on");
        setIsSpeaking(true);
    };

    const handlerOnStoppedSpeaking = (): void => {
        console.log("sound off");
        setIsSpeaking(false);
    };

    const { isRecording, results, startSpeechToText, stopSpeechToText } = useSpeechToText({
        continuous: true,
        crossBrowser: true,
        useOnlyGoogleCloud: true,
        googleApiKey: "AIzaSyARnh3MRMEIGIG0q0pMlTdrN_fpwtkDRrE",
        azureApiKey: "",
        azureRegion: "",
        useLegacyResults: false,
        timeout: 60000,
        onStartSpeaking: handlerOnStartSpeaking,
        onStoppedSpeaking: handlerOnStoppedSpeaking
    });

    useEffect(() => {
        void startSpeechToText();

        const timeout = setTimeout(() => {
            if (!hasSpokenRef.current) {
                onSilentTimeout?.();
            }
        }, silentTime * 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, []);

    useEffect(() => {
        const result = results.find((x) => x.transcript.toLowerCase().includes(word.toLowerCase()));

        if (result) {
            void stopSpeechToText();

            onMatch?.(result);
        }
    }, [results]);

    return (
        <div>
            <LMicrophone isSpeaking={isSpeaking} isRecording={isRecording} />
        </div>
    );
};

interface LWordMatchProps {
    word: string;
    silentTime: number;
    onSilentTimeout: () => void;
    onMatch: (result: ResultType) => void;
}
